<template>
  <ViewTransition>
    <div
      id="gtm-products"
      class="Products"
      v-hammer:swipe.horizontal="handleSwipe"
    >
      <ProductsHeader
        span="PRODUCTOS"
        :active="active"
        :length="model.length"
      />
      <div class="Products-logo">
        <router-link to="/">
          <img src="@/assets/img/logo.svg" />
        </router-link>
      </div>
      <div class="Products-background">
        <img
          v-for="(img, index) in bgImagesData"
          :key="index"
          :src="img.src"
          :style="img.style"
          :class="img.class"
        />
      </div>
      <div class="Products-slides">
        <ProductSlide
          v-for="(item, index) in model"
          :key="index"
          :index="index"
          :product="item"
          :animDirection="animDirection"
          v-show="index === active"
        />
        <div class="Products-slide-prev" v-if="isDesktop">
          <ShadowSlide
            v-for="(item, index) in model"
            :key="index"
            :index="index"
            :product="item"
            :images="images"
            :animDirection="animDirection"
            v-show="index === prevActive"
          />
        </div>
        <div class="Products-slide-next" v-if="isDesktop">
          <ShadowSlide
            v-for="(item, index) in model"
            :key="index"
            :index="index"
            :product="item"
            :images="images"
            :animDirection="animDirection"
            v-show="index === nextActive"
          />
        </div>
      </div>
      <div class="Products-navigation">
        <div class="Products-back" @click="() => back()" />
        <div class="Products-next" @click="() => next()" />
      </div>
      <router-link
        to="cb-donde-comprar"
        class="ProductSlide-goSix"
        ref="linkSix"
      >
        Dónde comprar
      </router-link>
      <p class="Products-excess">EVITE EL EXCESO</p>
    </div>
  </ViewTransition>
</template>

<script>
import { images } from "@/data/productsImages";
import model from "@/data/products.json";
import bgImages from "@/data/productsBackground.json";
import ViewTransition from "@/transitions/ViewTransition.vue";
import ProductSlide from "@/components/ProductSlide";
import ShadowSlide from "@/components/ShadowSlide";
import ProductsHeader from "@/components/ProductsHeader";
import TagFunctions from "@/assets/tagFunctions.js";

export default {
  name: "Products",
  components: {
    ViewTransition,
    ProductSlide,
    ProductsHeader,
    ShadowSlide,
  },
  data: () => ({
    model,
    bgImages,
    images,
    active: 0,
    prevActive: model.length - 1,
    nextActive: 1,
    animDirection: "right",
  }),
  computed: {
    bgImagesData() {
      const { bgImages, images } = this;
      return bgImages.map(image => {
        return {
          src: images[image.id],
          style: image.style,
          class: `Products-background-${image.id}`,
        };
      });
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
  },
  methods: {
    handleSwipe(ev) {
      if (ev.type == "swipeleft") this.next();
      else this.back();
    },
    back(dir = "left") {
      const { active, model } = this;
      const _active = active == 0 ? model.length - 1 : active - 1;
      this.animDirection = dir;
      this.prevActive = active;
      this.nextActive = _active == 0 ? model.length - 1 : _active - 1;
      this.active = _active;
    },
    next(dir = "right") {
      const { active, model } = this;
      const _active = active == model.length - 1 ? 0 : active + 1;
      this.animDirection = dir;
      this.prevActive = active;
      this.nextActive = _active == model.length - 1 ? 0 : _active + 1;
      this.active = _active;
    },
  },
  mounted() {
    TagFunctions.evPagePush('Productos', true, model.map((el) => {
      return {
        'productInfo': {
          'productName': el.title,
          'productCategory': 'Cerveza'
        }
      }
    }) )
  },
};
</script>

<style lang="stylus" scoped>
@import './Products.styl';
</style>
